import PartFooter from '@/components/Operational/Inventory/Parts/PartFooter';
import PartReplacementPartsForm from '@/components/Operational/Inventory/Parts/PartReplacementPartsForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { PartReplacementsFormValues } from '@/core/domain/operational/PartReplacement/PartReplacement.types';
import { PageProps } from '@/types/PageProps';
import { Form } from 'antd';
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { useInventoryPartFormContext } from '../../InventoryPartsProvider';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import AccessDenied from '@/components/_common/AccessDenied';

const PartReplacementPartsPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;

  const { partId } = useRouteMatch<{ partId: string }>().params;
  const { disabled, handleSubmit } = useInventoryPartFormContext();
  const [form] = Form.useForm<PartReplacementsFormValues>();

  return (
    <>
      <Helmet title={intl({ id: route.name })} />

      <DefaultRouteTabs
        route={route.parent}
        permissions={route.permissions}
        baseKey={partId}
        basePath={`/app/operational/inventory/parts/${partId}`}
        extra={
          <SpaceForButton>
            <SaveButton
              block
              type="primary"
              onClick={handleSubmit}
              disabled={
                disabled || !hasPermissions([Authorities.REGISTER_PART_EDIT])
              }
            >
              <FormattedMessage id="commons.entity.save" />
            </SaveButton>
          </SpaceForButton>
        }
      >
        {hasPermissions([Authorities.PART_REPLACEMENT_READ]) ? (
          <>
            <PartReplacementPartsForm form={form} />

            <PartFooter partId={Number(partId)} disabled={!disabled} />
          </>
        ) : (
          <AccessDenied />
        )}
      </DefaultRouteTabs>
    </>
  );
};

export default PartReplacementPartsPage;
